import {
  Accordion as ChakraAccordion,
  type AccordionProps as ChakraAccordionProps,
} from '@chakra-ui/react';

export type AccordionProps = ChakraAccordionProps;

export const Accordion = ({
  allowMultiple = true,
  allowToggle = true,
  ...props
}: AccordionProps) => {
  return (
    <ChakraAccordion
      allowMultiple={allowMultiple}
      allowToggle={allowMultiple ? undefined : allowToggle} // Chakra warns that if allowMultiple is true, allowToggle is ignored
      {...props}
    />
  );
};
